import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { READABLE_SURVEY_INPUT_PROCESSING_STATES } from '../../../Constants';
import { formatUnixTimestampToHumanReadableFormat } from '../../../utils/DateUtils';

const Details = ({
    trackingRecord,
    submissionRecord,
    participantMetadata,
    availableStatuses,
    loading,
    onAssignedToChange,
    onProcessingStatusChange,
    onSave
}) => {
    return (
        <div className="questionnaire-record-details">
            {/* Readonly Information */}
            <div className="mb-4">
                <Row>
                    <Col md={6}>
                        <div className="mb-3">
                            <div className="form-label text-muted" aria-label="Participant Name">Participant Name</div>
                            <div className="form-control-plaintext fs-5">{trackingRecord.participantName}</div>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="mb-3">
                            <div className="form-label text-muted" aria-label="Submission Date">Submission Date</div>
                            <div className="form-control-plaintext fs-5">{formatUnixTimestampToHumanReadableFormat(trackingRecord.submissionDate)}</div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <div className="mb-3">
                            <div className="form-label text-muted" aria-label="Re-submission">Re-submission</div>
                            <div className="form-control-plaintext fs-5">{trackingRecord.isResubmission ? 'Yes' : 'No'}</div>
                        </div>
                    </Col>
                    {submissionRecord && <Col md={6}>
                        <div className="mb-3">
                            <div className="form-label text-muted" aria-label="Submitter Email">Submitter Email</div>
                            <div className="form-control-plaintext fs-5">{submissionRecord.submitterEmail}</div>
                        </div>
                    </Col>}
                </Row>
                <Row>
                    <Col md={6}>
                        <div className="mb-3">
                            <div className="form-label text-muted" aria-label="Account Executive">Account Executive</div>
                            <div className="form-control-plaintext fs-5">{participantMetadata.accountExecutiveName}</div>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="mb-3">
                            <div className="form-label text-muted" aria-label="Account Executive Email">Account Executive Email</div>
                            <div className="form-control-plaintext fs-5">{participantMetadata.accountExecutiveEmail}</div>
                        </div>
                    </Col>
                </Row>
            </div>
            {/* Editable Fields */}
            <div className="mb-4">
                <Row>
                    <Col md={6}>
                        <Form.Group controlId="assignedTo">
                            <Form.Label>Assigned To</Form.Label>
                            <Form.Control
                                type="text"
                                value={trackingRecord.assignedTo}
                                onChange={(e) => onAssignedToChange(e.target.value)}
                                className="form-control-lg"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="processingStatus">
                            <Form.Label>Processing Status</Form.Label>
                            <Form.Select
                                value={trackingRecord.processingStatus}
                                onChange={(e) => onProcessingStatusChange(e.target.value)}
                                className="form-select-lg"
                            >
                                {availableStatuses.map(([key, value]) => (
                                    <option key={value} value={value}>
                                        {READABLE_SURVEY_INPUT_PROCESSING_STATES[value]}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={2}>
                        <Button
                            variant="primary"
                            onClick={onSave}
                            disabled={loading}
                            size="lg"
                            className="w-100"
                        >
                            {loading ? (
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    aria-hidden="true"
                                />
                            ) : (
                                <i className="fa fa-save" title="Save"></i>
                            )}
                        </Button>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

Details.propTypes = {
    trackingRecord: PropTypes.shape({
        participantName: PropTypes.string.isRequired,
        submissionDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        isResubmission: PropTypes.bool,
        assignedTo: PropTypes.string,
        processingStatus: PropTypes.string
    }).isRequired,
    submissionRecord: PropTypes.shape({
        submitterEmail: PropTypes.string
    }),
    participantMetadata: PropTypes.shape({
        accountExecutiveName: PropTypes.string,
        accountExecutiveEmail: PropTypes.string
    }).isRequired,
    availableStatuses: PropTypes.arrayOf(
        PropTypes.arrayOf(PropTypes.string)
    ).isRequired,
    loading: PropTypes.bool.isRequired,
    onAssignedToChange: PropTypes.func.isRequired,
    onProcessingStatusChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
};

export default Details; 